var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 85,
    viewBox: "0 0 122 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2823 26.9055C29.4709 26.9055 29.6973 26.8677 29.8859 26.8677C30.8666 26.8677 31.8474 26.8677 32.8281 26.9809C36.3361 11.5848 50.1419 0 66.6636 0C85.8258 0 101.329 15.4339 101.329 34.4903C101.329 35.6601 101.254 36.7922 101.14 37.9243C112.834 38.9431 122 49.2827 122 61.1694C122 73.7731 111.891 84.7164 99.2544 84.7164H29.2823C13.4773 84.7164 0.68998 71.6222 0.68998 55.9241C0.68998 40.2261 13.4773 26.9055 29.2823 26.9055Z",
    fill: "#A797D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud2.231e99478bfbd9613b74466f4db11c6e.svg";
export { ForwardRef as ReactComponent };